export default __webpack_public_path__ + "static/media/room-9.7dee4920.jpeg";